import { SocketMessageBaseModel } from './base/socketMessageBase.model';

export interface EventResponseMessageModel extends SocketMessageBaseModel {
  /**
   * O nome do evento.
   * Ex: 'Teste evento'
   */
  eventName: string;

  /**
   * O link para entrar na chamada de vídeo do evento.
   */
  eventJoinLink: string;

  /**
   * A data e hora de início do evento (já convertida para objeto Date).
   */
  eventStartTime: Date;

  /**
   * A data e hora de término do evento (já convertida para objeto Date).
   */
  eventEndTime: Date;

  /**
   * O nome do local do evento, se houver.
   * Ex: 'Rua c'
   */
  eventLocationName?: string;

  /**
   * Indica se o evento foi cancelado.
   */
  isCanceled: boolean;

  /**
   * Descrição opcional do evento.
   * Ex: 'Reunião de equipe'
   */
  eventDescription?: string;
}

export enum EventResponseStatus {
  GOING = 'GOING',
  NOT_GOING = 'NOT_GOING',
  MAYBE = 'MAYBE',
}
